import { j as r } from "../../../jsx-runtime-p91LotPX.mjs";
import { GrowFlex as e } from "../../Flex/Flex.js";
import { p } from "../../../styled-components.browser.esm-DBaC0ZEI.mjs";
import { CancelButton as i, SaveButton as c } from "../ActionButtons.js";
const x = p(e)`
  padding: var(--space-12) var(--space-20);
  border-radius: 0px 0px var(--br-3) var(--br-3);
  height: inherit;
`;
function f(o) {
  const {
    saveButtonProps: s,
    cancelButtonProps: n,
    style: a,
    extra: t
  } = o;
  return /* @__PURE__ */ r.jsxs(x, { justify: t ? "space-between" : "flex-end", style: {
    ...a
  }, children: [
    t,
    /* @__PURE__ */ r.jsxs(e, { align: "center", children: [
      /* @__PURE__ */ r.jsx(i, { ...n }),
      /* @__PURE__ */ r.jsx(c, { ...s })
    ] })
  ] });
}
export {
  f as GrowFormFooter
};
//# sourceMappingURL=FormFooter.js.map
